/**
 * Compact breadcrumb nav shown on individual config sub-pages.
 * Links back to the Setup Hub and lets users jump between sibling pages.
 */
import { NavLink } from "react-router-dom";
import {
  CalendarDays,
  CalendarRange,
  FileSpreadsheet,
  LayoutDashboard,
  ListChecks,
  Settings,
} from "lucide-react";

const CONFIG_PAGES = [
  { label: "Leave Year",        to: "/hr/leave/year-policies",     icon: CalendarRange },
  { label: "Leave Types",       to: "/hr/leave/policies",          icon: Settings },
  { label: "Entitlement Rules", to: "/hr/leave/entitlement-rules", icon: ListChecks },
  { label: "Holiday Calendar",  to: "/hr/leave/holidays",          icon: CalendarDays },
  { label: "Balances",          to: "/hr/leave/balances",          icon: FileSpreadsheet },
];

export function LeaveSetupTabs() {
  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-2xl border bg-slate-50 px-3 py-2">
      {/* Hub anchor */}
      <NavLink
        to="/hr/leave/setup"
        className="inline-flex items-center gap-1.5 rounded-xl bg-emerald-700 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-800"
      >
        <LayoutDashboard className="h-3.5 w-3.5" />
        Setup Hub
      </NavLink>

      <span className="select-none text-slate-300">|</span>

      {/* Sibling quick-nav */}
      {CONFIG_PAGES.map(({ label, to, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }) =>
            `inline-flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-xs font-bold transition ${
              isActive
                ? "bg-emerald-100 text-emerald-800"
                : "text-slate-500 hover:bg-white hover:text-slate-800"
            }`
          }
        >
          <Icon className="h-3.5 w-3.5" />
          {label}
        </NavLink>
      ))}
    </div>
  );
}
